import { AnyObject } from 'antd/es/_util/type'
import { ItemType } from 'antd/es/menu/interface'

export const findMatchingMenuKey = (pathname: string, items: ItemType[]) => {
  let exactMatch: string | undefined
  let partialMatch: { key?: string; depth: number } = {
    key: undefined,
    depth: 0
  }

  const traverse = (items: ItemType[], depth: number) => {
    for (const item of items) {
      if (!item || typeof item !== 'object') continue

      const key = item.key?.toString()
      const label = 'label' in item ? (item as AnyObject).label : undefined
      const linkPath = label?.props?.to?.toString() ?? ''

      if (linkPath) {
        if (pathname === linkPath) {
          exactMatch = key
        }

        const currentDepth = linkPath.split('/').length
        if (
          pathname.startsWith(linkPath) &&
          currentDepth > partialMatch.depth
        ) {
          partialMatch = { key, depth: currentDepth }
        }
      }

      if ('children' in item && Array.isArray(item.children)) {
        traverse(item.children, depth + 1)
      }
    }
  }

  traverse(items, 0)
  return exactMatch ?? partialMatch.key
}
